import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container mt-5" }
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, " Login ", -1)
const _hoisted_6 = { class: "card-body text-left" }
const _hoisted_7 = { class: "mt-2 col" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email", -1)
const _hoisted_9 = { class: "mt-2 col" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "password" }, "Senha", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2 col text-right" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "btn btn-primary"
  }, "Entrar")
], -1)

import {reactive} from "vue";
import {authService} from "@/services/auth.service";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const data = reactive({
  email: '',
  password: ''
});

async function login(){
  await authService.login(data.email, data.password);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("form", {
              onSubmit: _withModifiers(login, ["prevent"])
            }, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _withDirectives(_createElementVNode("input", {
                  type: "email",
                  class: "form-control",
                  id: "email",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((data.email) = $event)),
                  required: ""
                }, null, 512), [
                  [_vModelText, data.email]
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _withDirectives(_createElementVNode("input", {
                  type: "password",
                  class: "form-control",
                  id: "password",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data.password) = $event)),
                  required: ""
                }, null, 512), [
                  [_vModelText, data.password]
                ])
              ]),
              _hoisted_11
            ], 32)
          ])
        ])
      ])
    ])
  ]))
}
}

})